import React from "react"
import PropTypes from "prop-types"
import { useIntl } from "gatsby-plugin-intl"

import getPropertyTypeDescription from "utils/getPropertyTypeDescription"
import getProjectTypeDescription from "utils/getProjectTypeDescription"
import H from "components/atoms/H"
import {
  StyledWrapper,
  StyledImg,
  StyledType,
  StyledTextWrapper,
  titleStyles,
  StyledAddress,
  StyledImgWrapper,
  StyledDetailsLink,
  StyledLineWrapper,
  StyledTypeContainer,
} from "./ProjectBlock.styles"

const ProjectBlock = ({ project, type }) => {
  const { formatMessage } = useIntl()

  const {
    name,
    overview: { city },
    bannerImages,
    primaryPropertyTag,
    projectTag,
  } = project

  return (
    <StyledWrapper type={type}>
      <StyledTypeContainer>
        <StyledType>
          {getPropertyTypeDescription(primaryPropertyTag)}
        </StyledType>
        {type !== "secondary" && (
          <>
            <StyledType>{getProjectTypeDescription(projectTag)}</StyledType>
          </>
        )}
      </StyledTypeContainer>

      <StyledImgWrapper>
        {bannerImages[0] && (
          <StyledImg src={bannerImages[0].image} alt="" loading="lazy" />
        )}
      </StyledImgWrapper>
      <StyledTextWrapper>
        <H as="h3" extraStyles={titleStyles}>
          {name}
        </H>
        <StyledLineWrapper>
          <StyledAddress>
            {city && `${city.name}, ${city.stateCode}`}
          </StyledAddress>
          {type === "secondary" && (
            <StyledDetailsLink>
              {formatMessage({
                id: "pages.portfolio.map.viewMore",
              })}
            </StyledDetailsLink>
          )}
        </StyledLineWrapper>
      </StyledTextWrapper>
    </StyledWrapper>
  )
}
ProjectBlock.propTypes = {
  project: PropTypes.shape({
    slug: PropTypes.string,
    overview: PropTypes.shape({
      status: PropTypes.string,
      city: PropTypes.shape({
        name: PropTypes.string,
        stateCode: PropTypes.string,
      }),
    }),
    primaryPropertyTag: PropTypes.string,
    projectTag: PropTypes.string,
    id: PropTypes.string,
    bannerImages: PropTypes.arrayOf(
      PropTypes.shape({
        image: PropTypes.oneOfType([
          PropTypes.shape({
            original: PropTypes.string,
            large: PropTypes.string,
            medium: PropTypes.string,
            small: PropTypes.string,
          }),
          PropTypes.string,
        ]),
        id: PropTypes.string,
      })
    ),
    name: PropTypes.string,
  }).isRequired,
  type: PropTypes.string,
}

ProjectBlock.defaultProps = {
  type: "primary",
}
export default ProjectBlock
